import React from 'react';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import style from './ohCleoTeam.module.css';

const OhCleoTeam = () => {
  const data = useStaticQuery(
  graphql`
    query {
      allContentfulAssetLists(filter: { name: { eq: "Oh Cleos Hot Staff" } }) {
        edges {
          node {
            id
            name
            body
            asset {
              id
              description
              subDescription
              asset {
                fluid(maxHeight: 270) {
                  ...GatsbyContentfulFluid
                }
                file {
                  url
                }
                fixed {
                  aspectRatio
                }
                description
              }
              photoCredit
              downloadLink
            }
          }
        }
      }
    }
  `,
);

const assetsData = data.allContentfulAssetLists.edges[0].node.asset;
const { name, body } = data.allContentfulAssetLists.edges[0].node;

  return (
    <section className={style.ohCleoTeamWrapper}>
      <div className={style.teamDescription}>
        <h3>{name}</h3>
        <p>{body}</p>
      </div>
      <div className={style.teamContainer}>
        {assetsData.map((assetObject, i) => {
          return (
          <span key={i}>
            <div className={style.teamImageWrapper}>
              <Img
                fluid={assetObject.asset[0].fluid}
                alt={assetObject.subDescription}
                css={{ borderRadius: '6px' }}
              />
            </div>
            <h5>{assetObject.description}</h5>
            <p className="bodytext-2">{assetObject.subDescription}</p>
          </span>
        );})}
      </div>
    </section>
  );
};

export default OhCleoTeam;
